module.exports = __webpack_public_path__ + "img/icon-question-rating-radio_button-hover.624cef0d.svg";